/**
 * @param {{ value: number; installments: number; }} [options={ value = 0, installments = 0 }]
 */
export function calcParcelas(options = {}) {
  const { installments = 0, value = 0 } = options;
  const parsedInstallments = Math.max(installments, 1);

  return Number(Number(value / parsedInstallments).toFixed(2));
}
